module.exports = __webpack_public_path__ + "img/tngewallet.2825fc03.svg";